import { Button } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(1, 0, 3),
        display: 'flex',
        maxWidth: '900px',
        width: '100%',
    },
    buttonItem: {
        minWidth: '150px',
        height: '50px',
        flex: 1,
        textAlign: 'center',
        borderBottom: `4px solid ${theme.palette.primary.main}`,
    },
    defaultButton: {
        minWidth: '150px',
        height: '50px',
        textAlign: 'center',
        flex: 1,
        background: "#ccc",
        borderBottom: '4px solid #ccc'
    }
}))

export default function NavigationComponent({ isDisabled }) {
    const classes = useStyles();
    const { pathname } = useLocation();
    const isActive = (route) => pathname === route;
    return (
        <div className={classes.root}>
            <Button className={isActive('/provider-info') ? classes.buttonItem : classes.defaultButton}
                variant="contained"
                disableElevation
                disableRipple component={Link} to="/provider-info" disabled={isDisabled}>
                Overview
            </Button>
            <Button className={isActive('/branches') ? classes.buttonItem : classes.defaultButton}
                style={{ margin: '0 8px' }}
                variant="contained"
                disableElevation
                disableRipple component={Link} to="/branches" disabled={isDisabled}>
                Branches
            </Button>
            <Button className={isActive('/activities') ? classes.buttonItem : classes.defaultButton}
                variant="contained"
                disableElevation
                disableRipple component={Link} to="/activities" disabled={isDisabled}>
                Activities
            </Button>
        </div>
    );
}
